import React from "react";

const LazyCms = React.lazy(() => import("./cms"));

const Cms = (props: Record<string, any>) => (
  <React.Suspense fallback={<div className='transition-loader'><img src='/images/loader.svg' /></div>}>
    <LazyCms {...props} />
  </React.Suspense>
);

export default Cms;
